function scrollUp(e, dropdown) {
  const scrollContainer = document.querySelector('.offcanvas-body') || window;
  const navContainer = document.querySelector('.nav-container');

  if (dropdown && scrollContainer && navContainer) {
    const navContainerRect = navContainer.getBoundingClientRect();
    const dropdownRect = dropdown.getBoundingClientRect();
    let scrollTop = e.screenY - dropdownRect.y - navContainerRect.height;
    scrollContainer.scrollTo({
      behavior: 'smooth',
      top: scrollTop,
    });
  }
}

export function initializeHeaderNav() {
  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth;
  const dropdownLinks = document.querySelectorAll('.dropdown-toggle a');
  const dropdownItems = document.querySelectorAll('.dropdown-toggle');

  if (viewportWidth < 1200) {
    dropdownItems.forEach((dropDown) => {
      if (
        !dropDown.classList.contains('d-none') &&
        !dropDown.classList.contains('nav-link')
      ) {
        dropDown.addEventListener('click', (e) => {
          dropdownItems.forEach((subItem) => {
            if (
              subItem.classList.contains('d-xl-none') &&
              subItem.classList.contains('show')
            ) {
              scrollUp(e, dropDown);
            }
          });
        });
      }
    });

    dropdownLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.stopPropagation();
        window.location.href = link.href;
      });
    });
  }
}
